import { formatDataTest } from '@/common/dataTest/DataTest';
import { useDialog } from '@/common/dialog/DialogContext';
import { useInDialog } from '@/common/dialog/DialogScopeContext';
import { useFormFieldDef } from '@/common/form/hooks/useFormFieldDef';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormControl, FormHelperText, Icon, IconButton, Input, InputAdornment, InputLabel } from '@mui/material';
import { ProgPriceFormulaDialog } from './ProgPriceFormulaDialog';

export const ProgPriceFormulaValue = ({ fieldDef }) => {
  const inDialog = useInDialog();
  const { value, helperText, onBlur, error, disabled, setValue } = useFormFieldDef(fieldDef);
  const { openDialog } = useDialog();

  const handleClick = () => {
    const data = { formula: value ?? '' };
    openDialog(ProgPriceFormulaDialog, { data }).then((formula) => {
      onBlur();
      if (formula == null) return;
      setValue(formula);
    });
  };

  return (
    <FormControl error={error} disabled={disabled}>
      <InputLabel>{fieldDef.displayName}</InputLabel>
      <Input
        data-test-id={formatDataTest(inDialog ? 'dialog' : 'main', 'form-field', fieldDef.displayName)}
        value={value}
        onChange={(event) => setValue(event.target.value)}
        onBlur={onBlur}
        endAdornment={
          <InputAdornment position="end">
            <IconButton onClick={handleClick} edge="end">
              {!disabled && (
                <Icon>
                  <FontAwesomeIcon style={{ width: '100%' }} icon={fas.faPencil} />
                </Icon>
              )}
            </IconButton>
          </InputAdornment>
        }
      />
      <FormHelperText>{helperText}</FormHelperText>
    </FormControl>
  );
};
